"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseVTT = exports["default"] = void 0;
var _lodash = require("lodash");
var parseVTT = function parseVTT(vttCaptions) {
  var processedCaptions = [];
  try {
    var data = {
      start: undefined,
      end: undefined,
      captions: []
    };
    var foundTiming = false;
    if (vttCaptions) {
      var lines = vttCaptions.split(/\r?\n/g);
      for (var i = 0; i < lines.length; i += 1) {
        var line = lines[i];
        if (line.match(/^(\d\d:){1,2}(\d\d[.,])\d\d\d +--> +(\d\d:){1,2}(\d\d[.,])\d\d\d/g)) {
          var timing = line.match(/(\d\d:){1,2}(\d\d[.,])\d\d\d/g);
          if ((timing === null || timing === void 0 ? void 0 : timing.length) === 2) {
            foundTiming = true;
            for (var j = 0; j < timing.length; j += 1) {
              var time = timing[j];
              if (time.length === 10) {
                time = "00:".concat(time);
              }

              // Using Date object with the start set to the beginning of
              // what registers as 0 for getTime (1970-01-01)
              var date = new Date("1970-01-01T".concat(time, "Z"));
              var value = date.getTime();
              if (j === 0) {
                data.start = value;
              } else {
                data.end = value;
              }
            }
          }
        } else if (foundTiming) {
          if (line) {
            data.captions.push(line);
          } else {
            foundTiming = false;
            processedCaptions.push(data);
            data = {
              start: undefined,
              end: undefined,
              captions: []
            };
          }
        }
      }
    }
  } catch (e) {
    console.error('Could not parse captions:', e);
    processedCaptions = [];
  }
  return (0, _lodash.sortBy)(processedCaptions, 'start');
};
exports.parseVTT = parseVTT;
var _default = {
  parseVTT: parseVTT
};
exports["default"] = _default;